<template>
  <div id="mapContainer"></div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, defineProps, computed } from 'vue'
import L, { Map } from 'leaflet'
import markerIconPng from '../../images/maps/marker-icon.png'

// Typy dla propsów
interface Marker {
  lat: number;
  lng: number;
  type: string;
  title: string;
  street: string;
  city: string;
  phones: string;
  email: string;
  website: string;
}

// Definicja propsów
const props = defineProps<{
  markers: Marker[] | string;
  errors: string[] | string;
  defaultColor: string;
  zoom: number;
}>()

// Przekształcanie danych markers i errors
const parsedMarkers = computed(() => {
  return typeof props.markers === 'string' ? JSON.parse(props.markers) : props.markers;
})

const parsedErrors = computed(() => {
  if(!props.errors) return [];
  return typeof props.errors === 'string' ? JSON.parse(props.errors) : props.errors;
})

// Inicjalizacja mapy
let map: InstanceType<typeof Map> | null = null

onMounted(() => {
  // Logowanie błędów (jeśli są)
  parsedErrors.value.forEach((el: string) => {
    console.log(el)
  })

  let map;

  if (parsedMarkers.value.length === 1) {
    map = L.map('mapContainer').setView([parsedMarkers.value[0].lat, parsedMarkers.value[0].lng], props.zoom)
  } else {
    map = L.map('mapContainer').setView([52.04445704605205, 19.50340866809421], props.zoom)
  }

  console.log(map)
  // Inicjalizacja mapy

  L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 18,
    minZoom: 6
  }).addTo(map)

  // Definicje ikon markerów
  const ashMarker = L.icon({
    iconUrl: markerIconPng,
    iconSize: [25, 41],
    iconAnchor: [12.5, 20.5],
  })

  // Dodawanie markerów na mapie
  parsedMarkers.value.forEach((marker: Marker) => {
    L.marker([marker.lat, marker.lng], {
      icon: ashMarker
    }).addTo(map).on('click', (e) => {
      L.popup()
        .setLatLng(e.latlng)
        .setContent(`<strong class="text-primary text-black">${marker.title}</strong><br>
          ${marker.street}<br>
          ${marker.city}<br>
          ${marker.phones ? marker.phones + '<br>' : ''}
          ${marker.email ? `<a class="text-primary text-black" href="mailto:${marker.email}">${marker.email}</a><br>` : ''}
          ${marker.website ? `<a class="text-primary text-black" href="${marker.website}">${marker.website}</a>` : ''}
        `)
        .openOn(map)
    })
  })
})

onBeforeUnmount(() => {
  if (map) {
    map.remove()
  }
})
</script>

<style scoped>
#mapContainer {
    width: 100%;
    height: 50vh;
    z-index: 10;
}
</style>
